export function renderSituacoes(situacao, listaSituacoes) {
  const itemEncontrado = listaSituacoes.find((item) => situacao === item.field);

  return (
    <span className="d-flex align-items-center">
      <i
        className="ph-fill ph-circle"
        style={{ color: itemEncontrado.cor, fontSize: 18, marginRight: 8 }}
      ></i>
      <span>{itemEncontrado.nome}</span>
    </span>
  );
}